<template>
    <span class="d-none">LabelData</span>
</template>
<script>
import axios from 'axios'
export default {
    name: 'LabelData',
    data() {
        return {
            labelOptions: [],
            labelFilterOptions: [],
        }
    },
    async mounted() {
        if (this.$store.state.isActiveToken != '1') {
            // console.log(this.currentDate);
        } else {
            await this.labelDataList();
        }
    },
    computed: {
        iAT() {
            return this.$store.state.user.roleId
        },
        LDS() {
            return this.$store.state.label.loadLabelData
        },
    },
    watch: {
        async iAT(newValue) {
            if (this.$store.state.user.roleId != '') {
                await this.labelDataList();
            }
            return newValue
        },
        async LDS(newValue) {
            if (this.$store.state.label.loadLabelData === 1) {
                await this.labelDataList();
            }
            return newValue
        },
    },
    methods: {
        async labelDataList() {
            if (this.$store.state.isActiveToken == '1' && this.$store.state.label.loadLabelData === 1) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.get(process.env.VUE_APP_API_URL + 'label/active')
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            const labelOpts = resp.data.data.records
                            this.labelOptions = [];
                            this.labelFilterOptions = [];
                            var len = labelOpts.length;
                            for (var i = 0; i < len; i++) {
                                this.labelOptions.push({
                                    id: labelOpts[i]._id,
                                    text: labelOpts[i].label
                                });
                                this.labelFilterOptions.push({
                                    value: labelOpts[i]._id,
                                    label: labelOpts[i].label
                                });
                            }
                            this.$store.state.label.loadLabelData = 2
                            this.$store.state.label.LabelList = this.labelOptions
                            this.$store.state.label.LabelFilterList = this.labelFilterOptions
                        }
                    })
                    .catch(error => {
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                    })
            }
        },
    },
}
</script>